import React, { useEffect, useState } from 'react'
import { getDiffTime } from 'lib/utils'
import { Chip, LinearProgress, makeStyles } from '@material-ui/core'
import { ERROR_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import AccessTimeIcon from '@material-ui/icons/AccessTime'

export const TimerDiffDate = ({
  date,
  standardMinutes = 10,
  gap = 5,
  rootStyle,
  activeColor = SUCCESS_COLORS[600],
  loseColor = ERROR_COLORS[600],
  hasOnlyHours = false,
  hasOnlyMinutes = false,
  isChip = false
}) => {
  const fontSize = rootStyle?.fontSize ? rootStyle?.fontSize : 14
  const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      fontSize,
      fontWeight: 400,
      lineHeight: '20px',
      gap,
      ...rootStyle,
      color: state.isLoseTime ? loseColor : activeColor
    }
  }))
  const [state, setState] = useState({
    currentTime: null,
    isLoseTime: false
  })

  const classes = useStyles()

  const countDownDate = new Date().getTime()
  useEffect(() => {
    const interval = setInterval(() => {
      getTime()
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [countDownDate])

  const getTime = () => {
    const { days, hours, minutes, seconds } = getDiffTime(date)
    const hh = hours?.toString()?.length > 1 ? hours : '0' + hours
    const mm = minutes?.toString()?.length > 1 ? minutes : '0' + minutes
    const ss = seconds?.toString()?.length > 1 ? seconds : '0' + seconds

    setState(prev => ({
      ...prev,
      isLoseTime: minutes > standardMinutes,
      currentTime: days ? `${days} д. ${hh}:${mm}:${ss}` : hh ? `${hh}:${mm}:${ss}` : `${mm}:${ss}`
    }))
  }

  if (isChip) {
    const color = state.isLoseTime ? loseColor : activeColor
    const backgroundColor = state.isLoseTime ? ERROR_COLORS[50] : SUCCESS_COLORS[50]
    const borderColor = state.isLoseTime ? ERROR_COLORS[200] : SUCCESS_COLORS[200]

    return state.currentTime ? (
      <Chip
        style={{
          color,
          backgroundColor,
          border: `1px solid ${borderColor}`
        }}
        avatar={<AccessTimeIcon style={{ fontSize: 12, color }} />}
        label={state.currentTime}
      />
    ) : (
      <LinearProgress style={{ width: '100%' }} />
    )
  }

  return (
    <div className={classes.root}>
      <AccessTimeIcon style={{ fontSize: fontSize + 2 }} />
      {state.currentTime || <LinearProgress style={{ width: '100%' }} />}
    </div>
  )
}
